<script setup>
import ErrorSmall    from "@/components/form/ErrorSmall.vue";
import LabelForInput from "@/components/form/LabelForInput.vue";
import DeleteInputIcon from "@/components/form/DeleteInputIcon.vue";
defineProps({
  hint: "",
  label: "",
  hintFirst: "",
  hintLast: "",
  labelFirst: "",
  labelLast: "",
  nameFirst: "",
  nameLast: "",
  placeholderFirst: "",
  placeholderLast: "",
  requiredFirst: "",
  requiredLast: "",
  valueFirst: "",
  valueLast: "",
  errorFirst: "",
  errorLast: "",
});

const emits = defineEmits(['validateFirst', 'validateLast', 'update:valueFirst', 'update:valueLast']);
</script>

<template>
  <div class="form-row">
    <div class="col">
      <div :class="['form-group', requiredFirst && 'required']">
        <LabelForInput :name="nameFirst" :hint="hintFirst" :label="labelFirst" />
        <div>
          <div class="input-container">
            <input type="text"
              :class="['form-control', errorFirst && 'error-border']"
              :id="nameFirst"
              :name="nameFirst"
              :minlength="2"
              maxlength="50"
              :required="requiredFirst"
              :value="valueFirst"
              @input="$emit('update:valueFirst', $event.target.value)"
              @blur="$emit('validateFirst', $event)"
            />
            <DeleteInputIcon v-if="errorFirst" @clearInput="valueFirst = ''" />
          </div>
        </div>
        <ErrorSmall :nameFirst :error="errorFirst" :label="labelFirst"/>
      </div>
    </div>
    <div class="col">
      <div :class="['form-group', requiredLast && 'required']">
        <LabelForInput :name="nameLast" :hint="hintLast" :label="labelLast" />
        <div>
          <div class="input-container">
            <input type="text"
              :class="['form-control','max-width', errorLast && 'error-border']"
              :id="nameLast"
              :name="nameLast"
              :minlength="2"
              maxlength="50"
              :required="requiredLast"
              :value="valueLast"
              @input="$emit('update:valueLast', $event.target.value)"
              @blur="$emit('validateLast', $event)"
            />
            <DeleteInputIcon v-if="errorLast" @clearInput="valueLast = ''" />
          </div>
        </div>
        <ErrorSmall :nameLast :error="errorLast" :label="labelLast"/>
      </div>
    </div>
  </div>
</template>
<style scoped>
.max-width {
  max-width: 500px;
}
</style>